export function exportToCsv(filename, rows) {
  // const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
  let str =
    `${Object.keys(rows[0])
      .map(value => `"${value}"`)
      .join(",")}` + "\r\n";

  const csvFile = rows.reduce((str, next) => {
    str +=
      `${Object.values(next)
        .map(value => `"${value}"`)
        .join(",")}` + "\r\n";
    return str;
  }, str);

  downloadCsv(filename, csvFile);
}

export function downloadCsv(filename, rows) {
  var blob = new Blob([rows], { type: "text/csv;charset=utf-8;" });
  if (navigator.msSaveBlob) {
    // IE 10+
    navigator.msSaveBlob(blob, filename);
  } else {
    var link = document.createElement("a");
    if (link.download !== undefined) {
      // feature detection
      // Browsers that support HTML5 download attribute
      var url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", filename);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils.js